const isEN = shoptet.cookie.get("language") === "en";

const instagram = `
  <div class="instagram">
    <div class="instagram__inner">
      instagram
    </div>
  </div>
`;

export { instagram };
